<template>
  <div class="col-12">
    <div class="search-padd">
      <div class="scraping_header"></div>
      <div style="clear: both;" class="margin-bottom-10"></div>
      <div class="row pt-2">
      <div class="col-2">
        <div class="list-group" id="list-tab" role="tablist">
          <a class="list-group-item list-group-item-action" :class="{active: (selectedComponent === 'PathwaysTab' || selectedComponent === 'PathwayStepTab') || selectedComponent === 'PathwayShowTab'}" id="tab_pathways" data-toggle="list" @click="selectedComponent='PathwaysTab'"
            role="tab" aria-controls="home">Pathways</a>
          <a class="list-group-item list-group-item-action" 
          :class="{active: selectedComponent === 'CoursesTab'}" @click="selectedComponent='CoursesTab'" 
          id="tab_courses" data-toggle="list"
            role="tab" aria-controls="profile">Courses</a>
          <a class="list-group-item list-group-item-action" 
          :class="{active: selectedComponent === 'AssessmentsTab'}" @click="selectedComponent='AssessmentsTab'" 
          id="tab_assessments" data-toggle="list"
             role="tab" aria-controls="messages">Assessments</a>
          <a class="list-group-item list-group-item-action" 
          :class="{active: selectedComponent === 'TasklistsTab'}" @click="selectedComponent='TasklistsTab'" 
          id="tab_tasklists" data-toggle="list" 
            role="tab" aria-controls="settings">Skill Sets</a>
          <a class="list-group-item list-group-item-action" :class="{active: selectedComponent === 'FormsTab'}" @click="selectedComponent='FormsTab'" id="tab_forms" data-toggle="list" 
            role="tab" aria-controls="settings">Forms</a>
          <a class="list-group-item list-group-item-action" :class="{active: selectedComponent === 'CertificationsTab'}" @click="selectedComponent='CertificationsTab'" id="tab_certifications" data-toggle="list" 
            role="tab" aria-controls="settings">Certifications</a>
        </div>
      </div>




          <div class="col-10">
            <div class="tab-content" id="nav-tabContent">
              <component 
              :is="selectedComponent" 
              :ref="selectedComponent" 
              :pathwayId=pathwayId
              :accountId=accountId
              isPathwayTab=true>
              </component>
            </div>                
          </div>

        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { store } from '../../store/store';
import { Validator } from "vee-validate";
import moment from 'moment';
import PathwaysTab from './account_lookup_pathway_list_tab.vue';
import PathwayShowTab from './account_lookup_showpathway.vue';
import FormsTab from './account_lookup_forms_tab.vue';
import CertificationsTab from './account_lookup_pathway_certification_lists.vue';
import TasklistsTab from './account_lookup_tasklists_tab.vue';
import AssessmentsTab from './account_lookup_pathway_assessment_lists.vue';
import CoursesTab from './account_lookup_pathway_course_lists.vue';
import PathwayStepTab from './account_lookup_pathway_step.vue';
import PrivateTasklistsTab from './account_lookup_private_tasklists_tab.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
      props: ['accountId'],
      data() {
        return {
          selectedComponent: 'PathwaysTab',
          pathwayId: '',
        }
      },
      components: {
        TasklistsTab,
        FormsTab,
        CertificationsTab,
        PrivateTasklistsTab,
        PathwaysTab,
        AssessmentsTab,
        CoursesTab,
        PathwayStepTab,
        PathwayShowTab,
      },
      methods: {
        selectPathwayStepTab(pathwayId) {
          this.pathwayId = pathwayId;
          this.selectedComponent = 'PathwayStepTab';
        },
        showPathwayStepTab(pathwayId) {
          this.pathwayId = pathwayId;
          this.selectedComponent = 'PathwayShowTab';
        },
      },
      mounted() {
        EventBus.$on('VeeValidate', () => {
          this.$validator.validateAll();
        });
      },
      created() {
        setTimeout(() => {
          if(this.accountId > 0) {
            if((store.state.active_tab)) {
              this.selectedComponent = store.state.active_sub_tab;
              let page_url = '';
              let active_tab = '';
              let active_sub_tab = '';
              store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
            }
          }
        }, 500);

      }
}
</script>

<style scoped>
#list-tab a {
  margin-bottom: 5px;
  border-radius: 3px;
  padding: 4px 8px;
  border-color: #00ACEE;
  border-width: 1px;
  color: #000000;
  border-radius: 5px;
  cursor: pointer;
}

#list-tab a:active,
.list-group-item.active {
  background-color: #00ACEE;
  color: #FFFFFF !important;
}
.pathways_step {
  font-size: 13px;
}
.pathway_objectives_box .d-flex div {
  width: 85px;
  margin-bottom: 15px;
  cursor: pointer;
}
.pathway_objective_focus {
  color: #00ACEE !important;
  background-color: #f0f9fc !important;
  border-color: #6cc2e2 !important;
  border: 1px solid #6cc2e2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_pathway_tab.vue